/**
 * Compares two semver strings ("major.minor.patch").
 * Returns >0 if a > b, 0 if equal, <0 if a < b. Missing segments count as 0.
 */
export function compareVersions(a: string, b: string): number {
  const pa = a.split('.').map(Number);
  const pb = b.split('.').map(Number);
  for (let i = 0; i < 3; i++) {
    const diff = (pa[i] ?? 0) - (pb[i] ?? 0);
    if (diff !== 0) return diff;
  }
  return 0;
}
